// removed by extract-text-webpack-plugin
module.exports = {"carousel":"carousel___2R0nD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.scss
// module id = ssAn
// module chunks = 57